import { getEnvData } from '@src/utils';
import axios from 'axios';
export type { AxiosRequestConfig as RequestConfig } from 'axios';

const ENV_DATA = getEnvData();

export const userBaseURL = ENV_DATA.API_BASE_URL;
export const businessBaseURL = ENV_DATA.BUSINESS_API_BASE_URL;

export const BusinessAxiosConfig = axios.create({
  baseURL: businessBaseURL,
  timeout: 60000,
  showToastOnError: true
});

export const UserAxiosConfig = axios.create({
  baseURL: userBaseURL,
  timeout: 60000,
  showToastOnError: true
});

export const addTokenHeader = (token: string, type?: 'json' | 'formData') => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': type === 'formData' ? 'multipart/form-data' : 'application/json',
      ApplicationID: ENV_DATA.API_APPLICATION_ID,
      SecretKey: ENV_DATA.API_SECRET_KEY,
      /**
       * 1 = web
       */
      DeviceType: '1'
    }
  };
};
